import CreativeFileStatus from '@/Enums/Creatives/CreativeFileStatus.enum';
import CreativeType from '@/Enums/Creatives/CreativeType.enum';
import { ICreative } from '@/Interfaces/Creatives/Creative.interface';
import AudioPlayer from '@/components/AudioPlayer';
import TableActionButton from '@/components/Buttons/TableActionButton';
import ExportIcon from '@/components/Icons/ExportIcon';
import TextViewModal from '@/components/Modal/TextViewModal';
import { memo, useState } from 'react';

interface IProps {
  row: ICreative;
  handleViewCreative?: (row: ICreative) => void;
}

const PreviewCell = memo(({ row, handleViewCreative }: IProps) => {
  const [isTagViewModalOpen, setIsTagViewModalOpen] = useState(false);

  const notUploadedFileContent = (
    <div className='flex flex-col gap-1 items-center justify-center'>
      <p className='font-semibold'>
        {row.fileStatus === CreativeFileStatus.PROCESSING ? 'Processing' : 'Upload Failed'}
      </p>
      {[CreativeFileStatus.FAILED, null].includes(row.fileStatus) && handleViewCreative && (
        <TableActionButton variant='outlined' color='primary' onClick={() => handleViewCreative(row)}>
          <ExportIcon className='w-[11px] mr-[4px]' />
          <span>View</span>
        </TableActionButton>
      )}
    </div>
  );

  switch (row.type) {
    case CreativeType.VIDEO:
    case CreativeType.DISPLAY:
      return [CreativeFileStatus.UPLOADED, CreativeFileStatus.STORED_IN_BEESWAX].includes(row.fileStatus) ? (
        <img className='h-full' src={row.thumbnail!} alt='thumbnail' />
      ) : (
        notUploadedFileContent
      );
    case CreativeType.VIDEO_VAST:
    case CreativeType.DISPLAY_TAG:
    case CreativeType.AUDIO_VAST:
      return (
        <>
          <TableActionButton variant='outlined' color='primary' onClick={() => setIsTagViewModalOpen(true)}>
            <ExportIcon className='w-[11px] mr-[4px]' />
            <span>View Tag</span>
          </TableActionButton>
          <TextViewModal
            open={isTagViewModalOpen}
            handleClose={() => setIsTagViewModalOpen(false)}
            title='Tag Content'
            textContent={row.tagContent ?? ''}
          />
        </>
      );
    case CreativeType.AUDIO:
      return [CreativeFileStatus.UPLOADED, CreativeFileStatus.STORED_IN_BEESWAX].includes(row.fileStatus) ? (
        <AudioPlayer src={row.file!} />
      ) : (
        notUploadedFileContent
      );
    default:
      return <p className='font-semibold'>Preview not available</p>;
  }
});

export default PreviewCell;
